import { Partial } from '@40seas/entities/common';
import { BusinessVerification } from './business-verification';

export class UpdateBusinessVerificationDto extends Partial(BusinessVerification) {}
